import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { routingConstants } from "../Constants/routingConstants";
import {
  fetchNotificationHistory,
  updateNotificationPagination,
} from "../reducers/clientnotification";
import { allowPublishJob } from "../reducers/session";
const DashboardRedirect = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allowPublishJob());
    dispatch(
      updateNotificationPagination({
        currentPage: 1,
        isLastPage: false,
        totalPage: 1,
      }),
    );
    dispatch(fetchNotificationHistory({ countOnly: true }));
    // dispatch(getTotalUnreadCount());
  }, []);
  return (
    <Navigate
      to={state?._for ? state?._for : routingConstants.dashboard}
      replace={true}
    />
  );
};

export default DashboardRedirect;
